import styled from "@emotion/styled"
import { FlexContainer } from "../../../styled/flexbox.styled"

export const InputWrapperContainer = styled(FlexContainer)`
  width: 100%;
`
